







































import {Component, Prop, Vue} from "vue-property-decorator";
import Order from "@/api/Order";
import OrderHeaderView from "@/components/Dashboard/Orders/OrderHeaderView.vue";
import OrderItemView from "@/components/Dashboard/Orders/OrderItemView.vue";
import OrderShippingDetailsView from "@/components/Dashboard/Orders/OrderShippingDetailsView.vue";
import OrderPaymentDetailsView from "@/components/Dashboard/Orders/OrderPaymentDetailsView.vue";
import Loading from "@/components/Shared/Loading.vue";

@Component({
  components: {Loading, OrderPaymentDetailsView, OrderShippingDetailsView, OrderItemView, OrderHeaderView}
})
export default class OrderView extends Vue {
  @Prop() private order!: Order;
}
